import React from "react";

interface Props {
    fill: string;
}

export const XIcon: React.FC<Props> = ({ fill }) => {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18">
            <path
                fill={fill}
                d="M15.3,2.7c-0.4-0.4-1-0.4-1.4,0L9,7.6L4.1,2.7c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4L7.6,9l-4.9,4.9
                c-0.4,0.4-0.4,1,0,1.4s1,0.4,1.4,0L9,10.4l4.9,4.9c0.4,0.4,1,0.4,1.4,0s0.4-1,0-1.4L10.4,9l4.9-4.9C15.7,3.7,15.7,3.1,15.3,2.7z"
            />
        </svg>
    );
};
